module.exports = __webpack_public_path__ + "static/media/vip-message-background.dff87cc3.png";